export function data(state,data){
    state.data = data
}

export function disableForm(state,data){
    state.disableForm = data
}

export function dataList(state,dataList){
    state.dataList = dataList
}

export function limpaData(state){
    state.disableForm = false;       
    state.data = JSON.parse(JSON.stringify(state.dataDefault)); 
}

export function pagination(state,pagination){
    state.pagination = pagination
}

export function selectLookup(state,selectLookup){
    state.selectLookup = selectLookup
}
